"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isObject_1 = __importDefault(require("lodash/isObject"));
function deserializeObject(value, label) {
    if (!(0, isObject_1.default)(value)) {
        throw new Error(`${label !== null && label !== void 0 ? label : 'Value'} "${value}" is not an object`);
    }
    return value;
}
exports.default = deserializeObject;
